import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { circleButtonStyle } from '../ui_reusable/styles/Button.styles' // Updated import
import citrusAppLogo from '../../assets/citrus_logo.png'
import { InfoSmall500Style } from '../../styles/Text.styles'
import theme from '../../styles/theme'

export const MenuItemNoLink = styled.div`
  ${InfoSmall500Style}
  padding: 0.5rem 1rem;
`

export const WhiteNavbar = styled('div')`
  background-color: white;
  border-bottom: 1px solid #e5e5e5;
  padding: 0.5rem;
  border-radius: 1.2rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-bottom: 1.5rem;
  /* container: WhiteNavbar / inline-size; */
`

export const LeftAlignedContainer = styled.div`
  flex-grow: 1;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: left;
`

export const MiddleAlignedContainer = styled.div`
  flex-grow: 5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  gap: 2rem;
  padding-left: 0.5rem; //margin-right: clamp(0.0rem, 10%, 100%);
  //container: MiddleAlignedContainer / inline-size;

  /* @ts-ignore */
  @container WhiteNavbar (max-width: 960px) {
    gap: 1rem;
  }
  /* @ts-ignore */
  @container WhiteNavbar (max-width: 840px) {
    gap: 0rem;
  }
  /* @ts-ignore */
  @container WhiteNavbar (max-width: 770px) {
    display: inline-block;
  }
`

export const RightAlignedContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  gap: 1rem;
  min-width: 12rem;
  min-height: 2.8rem;
  padding-right: 1rem;
`

export const AppLogo = styled(Link)`
  background-image: url(${citrusAppLogo});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 1.66rem;
  width: 10rem;
  margin-left: clamp(0.5rem, calc(60% - 8rem), 100%);
  margin-right: 1.2rem;
  cursor: pointer;
`

export const AppLogoCentered = styled(AppLogo)`
  margin-left: 0;
  margin-right: 0;
`

export const LoggedOutBar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  flex: 1;
  min-height: 2.8rem;
`

export const LoggedOutSide = styled.div<{ $align?: 'start' | 'end' }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.$align === 'end' ? 'flex-end' : 'flex-start'};
  min-height: 2.8rem;
  padding-right: ${(props) => (props.$align === 'end' ? '1rem' : '0')};
`

export const IconButton = styled.button`
  ${circleButtonStyle}
`

export const UserProfile = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5rem;
`

export const UserName = styled.div`
  font-size: 0.8rem;
  font-weight: bold;
`

export const UserEmail = styled.div`
  font-size: 0.74rem;
  color: #6b7280;
`

// Add new styled component for client logo
export const ClientLogo = styled.img`
  max-height: 2rem;
  height: auto;
  width: auto;
  display: block;
  margin: 0 auto;
`

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 0.4rem;
`

export const ProjectListContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1.2rem;
  gap: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.4rem;
`

export const ProjectListElement = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.3rem 0.5rem;
  border-radius: 0.3rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.colors.secondaryVeryVeryLight};
  }

  &:active {
    background-color: ${theme.colors.second};
  }
`

export const ProjectListTitle = styled.span`
  ${InfoSmall500Style};
  padding-left: 0.6rem;
`
